import {CheckboxAloneFilterController} from 'plugins/modules/filter/components/CheckboxAloneFilterController';
import {CheckboxFilterController} from 'plugins/modules/filter/components/CheckboxFilterController';
import {ChipsFilterController} from 'plugins/modules/filter/components/ChipsFilterController';
import {RangeFilterController} from 'plugins/modules/filter/components/RangeFilterController';
import {FilterCustomViewType, FilterType, IFilterFacet} from 'plugins/modules/filter/types';
import React, {FC} from 'react';
import {CHECKBOX_TYPES, RANGE_TYPES} from 'plugins/modules/filter/constants';

interface IProps {
    filter: IFilterFacet;
    withSearch?: boolean;
}

export const FilterFactory: FC<IProps> = ({filter, withSearch}) => {
    const {customView, type} = filter;

    if (CHECKBOX_TYPES.includes(type)) {
        return customView === FilterCustomViewType.CHIPS ? (
            <ChipsFilterController filter={filter} />
        ) : (
            <CheckboxFilterController filter={filter} withSearch={withSearch} />
        );
    }

    if (RANGE_TYPES.includes(type)) {
        return <RangeFilterController filter={filter} />;
    }

    if (type === FilterType.ALONE_CHECKBOX) {
        return <CheckboxAloneFilterController filter={filter} />;
    }

    return null;
};
